<template>
  <div class="dynamic-container">
    <div class="fixed">
      <div class="warning">
        <span class="rank">学员排行榜</span>
        高风险会员<span>{{ rank_num }}</span
        >人
        <span class="warn-btn user-btn" @click="toWarningMembers"
          >点我查看</span
        >
      </div>
      <div class="select-list">
        <div class="select-item" @click="bindDietChange()">
          {{ dietSelectData.text }}
        </div>
        <div class="select-item" @click="bindMemberChange()">
          {{ memberSelectData.text }}
        </div>
        <div class="select-item" @click="bindTimeChange()">
          {{ timeSelectData.text }}
        </div>
        <div class="clear" @click.stop="bindClear">清除</div>
      </div>
      <!--  -->
      <div
        class="select-container"
        v-if="
          dietSelectData.data.p_type == 3 || dietSelectData.data.p_type == 2
        "
      >
        <div>
          <div class="select-title">打卡类型</div>
          <div class="button-list" v-if="dietSelectData.data.p_type == 3">
            <div
              class="button-item"
              :class="{
                'button-item-active': dietSelectData.data.curMeal === btnindex
              }"
              v-for="(btnitem, btnindex) in mealArray"
              :key="btnindex"
              @click.stop="selectMeal(btnindex)"
              >{{ btnitem }}</div
            >
          </div>
          <div class="button-list" v-if="dietSelectData.data.p_type == 2">
            <div
              class="button-item"
              :class="{
                'button-item-active': dietSelectData.data.type2 === btnindex
              }"
              @click.stop="selectTest(btnindex)"
              v-for="(btnitem, btnindex) in testArray"
              :key="btnindex"
              >{{ btnitem }}</div
            >
          </div>
        </div>
      </div>
      <!--  -->
      <div class="nav-list">
        <div
          class="nav-item"
          :class="{ 'nav-item-active': curNav == index }"
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="changeNav(index)"
        >
          <span>{{ item.name }}</span
          ><span v-if="index == 0 && item.total">({{ item.total }})</span>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div
        class="page-scroll"
        @scroll="bindScroll($event, index)"
        :ref="'scroll-' + index"
        v-for="(item, index) in navList"
        :key="index"
        v-show="curNav == index"
      >
        <van-pull-refresh
          style="min-height: 100%"
          v-model="navList[curNav].refreshing"
          @refresh="onRefresh(curNav)"
        >
          <van-list
            style="min-height: 80vh"
            v-if="item.loaded"
            v-model="item.isLoading"
            :finished="item.finished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="loadData(index, item.time, item.page, false)"
          >
            <!-- <div
            v-for="(item1, index1) in item.data"
            :key="index1"
            style="
              width: 100%;
              height: 300px;
              border: 1px solid #000;
              box-sizing: border-box;
            "
          ></div> -->
            <ReviewsItem
              v-if="curNav == 0"
              :type="1"
              :data="item.data"
              @like="likeDynamic"
              @into="intoDynamic"
              @userinfo="intoInfo"
            ></ReviewsItem>
            <ReviewsItem
              v-if="curNav == 1"
              :type="2"
              :data="item.data"
              @like="likeDynamic"
              @into="intoDynamic"
              @userinfo="intoInfo"
            ></ReviewsItem>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- 餐卡类型选择 -->
    <van-popup v-model="dietSelectData.showPicker" position="bottom">
      <van-picker
        show-toolbar
        :title="dietSelectData.title"
        :columns="dietSelectData.list"
        :value-key="dietSelectData.key"
        :default-index="dietSelectData.default"
        @cancel="bindDietCancel"
        @confirm="bindDietConfirm"
      />
    </van-popup>
    <!-- 会员选择 -->
    <van-popup v-model="memberSelectData.showPicker" position="bottom">
      <van-picker
        show-toolbar
        :title="memberSelectData.title"
        :columns="memberSelectData.list"
        :value-key="memberSelectData.key"
        :default-index="memberSelectData.default"
        @cancel="bindMemberCancel"
        @confirm="bindMemberConfirm"
      />
    </van-popup>
    <!-- 时间选择 -->
    <van-popup v-model="timeSelectData.showPicker" position="bottom">
      <van-datetime-picker
        v-model="timeSelectData.value"
        type="date"
        title="选择年月日"
        :min-date="timeSelectData.minDate"
        :max-date="timeSelectData.maxDate"
        @cancel="bindTimeCancel"
        @confirm="bindTimeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { dietData, formatTime } from './data'
import ReviewsItem from './components/review-item.vue'
export default {
  name: 'nutritionist-tool-diet-list',
  components: { ReviewsItem },
  data() {
    return {
      id: '', //营期id
      rank_num: 0, //风险人数
      curSelect: 0,
      currentDate: new Date(), //当前时间
      mealArray: ['早餐', '午餐', '晚餐', '加餐'],
      testArray: ['入营', '日常', '结营'],
      dietSelectData: {
        index: 0,
        title: '餐卡类型',
        text: '饮食打卡',
        key: 'name',
        data: dietData[1],
        list: dietData,
        showPicker: false,
        default: 1
      },
      memberSelectData: {
        index: 0,
        text: '全部会员',
        key: 'truename',
        data: { truename: '全部会员', unify_id: '' },
        list: [],
        showPicker: false,
        title: '选择会员',
        default: 0
      },
      timeSelectData: {
        showPicker: false,
        data: '',
        value: new Date(),
        title: '选择时间',
        text: '全部日期',
        minDate: new Date(2010, 1, 1),
        maxDate: new Date()
      },
      curNav: 0,
      navList: [
        {
          name: '未点评',
          scrollTop: 0,
          isLoading: false,
          finished: false,
          loaded: false,
          total: '',
          time: '',
          page: 1,
          data: [],
          refreshing: false
        },
        {
          name: '已点评',
          scrollTop: 0,
          isLoading: false,
          finished: false,
          loaded: false,
          time: '',
          total: '',
          page: 1,
          data: [],
          refreshing: false
        }
      ],
      typeList: [1, 2],
      userAvg: null,
      showPicker: false
    }
  },
  watch: {
    $route(to, from) {
      //从新老点评详情界面返回则不刷新，其他情况刷新
      if (
        to.name == 'nutritionist-tool-diet-list' &&
        from.name !== 'nutritionist-tool-review-detail' &&
        from.name !== 'nutritionist-tool-review-old-detail' &&
        from.name !== 'user-data'
      ) {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  activated() {
    this.updateNotComment()
    this.initScroll()
  },
  methods: {
    updateNotComment() {
      let curNav = this.curNav
      let id = localStorage.getItem('finishedCommentId')
      if (!id || curNav != 0) {
        return
      }
      let delIndex
      let data = this.navList[curNav].data
      for (let i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          delIndex = i
          break
        }
      }
      if (delIndex !== undefined) {
        data.splice(delIndex, 1)
        this.navList[curNav].total--
      }
      localStorage.removeItem('finishedCommentId')
    },
    bindScroll(e, index) {
      let scrollTop = e.target.scrollTop
      this.navList[index].scrollTop = scrollTop
    },
    initScroll() {
      this.navList.map((item, index) => {
        if (item.loaded) {
          console.dir(this.$refs['scroll-' + index])
          let dom = this.$refs['scroll-' + index]
          dom = Array.isArray(dom) ? dom[0] : dom
          dom.scrollTo(0, item.scrollTop)
        }
      })
    },
    init() {
      //初始化data数据
      console.log('初始化')
      Object.assign(this.$data, this.$options.data())
      this.getQuery()
      this.loadData(this.curNav, '', 1, true)
    },
    getQuery() {
      if (this.$route.query.title) {
        document.title = this.$route.query.title
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
      }
    },
    bindDietChange() {
      this.dietSelectData.showPicker = true
    },
    bindMemberChange() {
      this.memberSelectData.showPicker = true
    },
    bindTimeChange() {
      this.timeSelectData.showPicker = true
    },
    //切换餐卡类型
    selectMeal(index) {
      this.dietSelectData.data.curMeal = index
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    selectTest(index) {
      this.dietSelectData.data.type2 = index
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    /*  */
    bindDietConfirm(item, index) {
      console.log(item)
      this.dietSelectData.showPicker = false
      this.dietSelectData.data = item
      this.dietSelectData.text = item.name
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    bindDietCancel() {
      this.dietSelectData.showPicker = false
    },
    bindMemberConfirm(item, index) {
      this.memberSelectData.showPicker = false
      this.memberSelectData.data = item
      this.memberSelectData.text = item.truename
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    bindMemberCancel() {
      this.memberSelectData.showPicker = false
    },
    bindTimeConfirm(date) {
      this.timeSelectData.showPicker = false
      let str = formatTime(date)
      this.timeSelectData.value = str
      this.timeSelectData.data = str
      this.timeSelectData.text = str
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    bindTimeCancel() {
      this.timeSelectData.showPicker = false
    },
    bindClear() {
      this.dietSelectData.data = this.dietSelectData.list[0]
      this.dietSelectData.text = this.dietSelectData.list[0].name
      this.memberSelectData.data = this.memberSelectData.list[0]
      this.memberSelectData.text = this.memberSelectData.list[0].truename
      this.timeSelectData.data = ''
      this.timeSelectData.text = '全部日期'
      this.clearLoaded()
      this.loadData(this.curNav, '', 1, true)
    },
    clearLoaded() {
      this.navList.map((item) => {
        item.loaded = false
        item.finished = false
      })
    },
    /*  */
    onRefresh(curNav) {
      this.navList[curNav].finished = false
      this.loadData(curNav, '', 1, true)
    },
    toWarningMembers() {
      if (!this.$http._isApp()) {
        //旧版本前往小程序
        wx.miniProgram.navigateTo({
          url: `/pages/leaderboard/leaderboard?title=${this.$route.query.title}&pid=${this.$route.query.id}`
        })
      }
    },
    changeNav(index) {
      if (this.curNav == index) {
        return
      }
      this.curNav = index
      this.navList[index].finished = false
      this.navList.map((item1, index1) => {
        if (index != index1) {
          item1.list = []
        }
      })
      this.loadData(index, '', 1, true)
    },
    bindPickerCancel() {
      this.showPicker = false
    },
    bindPickerConfirm(item, index) {
      this.showPicker = false
      if (item instanceof Date) {
        this.setTimeStr(item)
      } else {
        this.selectData[this.curSelect].index = index
        this.selectData[this.curSelect].text =
          this.selectData[this.curSelect].list[index][
            this.selectData[this.curSelect].key
          ]
      }
    },
    //获取餐卡类型
    getDietType(str) {
      let res
      this.selectData.map((item) => {
        if (item.val == 'diet') {
          res = item.list[item.index][str]
        }
      })
      return res
    },
    getMemberInfo() {
      let res
      this.selectData.map((item) => {
        if (item.val == 'member') {
          res = item.list.length && item.list[item.index].unify_id
        }
      })
      return res
    },
    getTimeStr() {
      let res
      this.selectData.map((item) => {
        if (item.val == 'time') {
          res = item.text == '全部日期' ? '' : item.text.replace(/\./g, '-')
        }
      })
      return res
    },
    setTimeStr(data) {
      this.selectData.map((item) => {
        if (item.val == 'time') {
          item.text = formatTime(data)
        }
      })
    },
    loadData(index = 0, time = '', page = 1, isCover = false) {
      this.navList[index].isLoading = true
      let type = this.typeList[index]
      let params = {
        pid: this.id,
        only_no_read: type,
        time: time,
        page: page,
        p_type: this.dietSelectData.data.p_type,
        curMeal: this.dietSelectData.data.curMeal,
        type2: this.dietSelectData.data.type2,
        unify_id: this.memberSelectData.data.unify_id || null,
        day: this.timeSelectData.data
      }
      this.$http
        .getApp('member/AppCampCoach/commentDataPageV2', params)
        .then((res) => {
          res = res.data
          if (res.data.userAvg) {
            this.userAvg = res.data.userAvg
          }
          if (res.code == 200) {
            this.addMemberList(res.data.user_list)
            this.rank_num = res.data.rank_num || 0
            if (res.data.list.data.length) {
              let arr = this.dealData(res.data.list.data)
              if (isCover) {
                this.navList[index].page = 1
                this.navList[index].data = arr
                this.$nextTick(() => {
                  let el = this.$refs['scroll-' + index]
                  el = Array.isArray(el) ? el[0] : el
                  el.scrollTop = 0
                })
              } else {
                this.navList[index].data = this.navList[index].data.concat(arr)
              }
              this.navList[index].page++
            } else {
              if (isCover) {
                this.navList[index].data = []
              }
              this.navList[index].finished = true
            }
            this.navList[index].time = res.data.time || ''
            this.navList[index].total = res.data.list.total
          }
          this.navList[index].isLoading = false
        })
        .catch((e) => {
          console.log(e)
          this.navList[index].isLoading = false
        })
        .finally(() => {
          this.navList[index].loaded = true
          this.navList[index].refreshing = false
        })
    },
    dealData(data) {
      data = data.map((item) => {
        item.content = item.content ? item.content.split(',') : []
        return item
      })
      return data
    },
    addMemberList(list) {
      if (!this.memberSelectData.list.length) {
        list.unshift({
          unify_id: '',
          truename: '全部会员'
        })
        this.memberSelectData.list = list.map((item) => {
          if (item.remark_name) {
            item.truename = item.remark_name
          }
          return item
        })
      }
    },
    //点赞动态
    likeDynamic(index, curNav) {
      curNav = +curNav - 1
      let is_love = this.navList[curNav].data[index].is_love
      let tid = this.navList[curNav].data[index].id
      let flag = 1
      if (is_love) {
        flag = 0
      }
      let params = {
        tab_type: 'weapp_group',
        tid,
        flag
      }
      this.$http
        .postApp('member/AppCamp/optionLove', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let zan_num = this.navList[curNav].data[index].zan_num
            this.navList[curNav].data[index].zan_num = flag
              ? ++zan_num
              : --zan_num < 0
              ? 0
              : zan_num
            this.navList[curNav].data[index].is_love = !is_love
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    intoDynamic(item, index) {
      let tabType = item.tab_type
      let id = item.id
      let curMeal = item.curMeal
      if (item.version_type == 1) {
        this.$router.push({
          path: '/nutritionist-tool/review-old-detail',
          query: {
            id,
            tabType,
            pid: this.id,
            curMeal,
            detailData: JSON.stringify(item)
          }
        })
        //旧版本前往小程序
        /* wx.miniProgram.navigateTo({
          url:
            "/package-ugc/pages/dietitianTool/reviewPage/reviewPage" +
            "?pid=" + this.id + "&id=" + id + "&tabType=" + tabType,
        }); */
      } else {
        //新版本在h5点评
        this.$router.push({
          path: '/nutritionist-tool/review-detail',
          query: {
            id,
            tabType,
            pid: this.id,
            curMeal
          }
        })
      }
    },
    intoInfo(item) {
      this.$router.push({
        name: 'user-data',
        query: {
          unify_id: item.unify_id,
          pid: this.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamic-container {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  height: 100vh;
  position: relative;
  .fixed {
    position: sticky;
    width: 100%;
    top: 0;
    .warning {
      width: 100%;
      box-sizing: border-box;
      height: 30px;
      text-align: center;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f04646;
      color: #fff;
      .rank {
        margin-right: 30px;
      }
      .warn-btn {
        font-weight: 700;
        font-size: 13px;
        margin-left: 5px;
      }
    }
    .select-list {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      padding-right: 10px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .select-item {
        font-weight: 600;
        position: relative;
        flex: 1;
        flex-shrink: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        height: 28px;
        padding: 0 10px;
        margin: 0 4px;
        display: flex;
        align-items: center;
        font-size: 12px;
        text-align: left;
        background-color: #ffffff;
        border-radius: 6px;
        border: solid 1px #f1f1f1;
      }
      .select-item::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 6px;
        width: 0;
        height: 0;
        transition: all 0.5s;
        transform: translate(0, -25%);
        border-left: 5px solid #fff;
        border-right: 5px solid #fff;
        border-top: 5px solid #bbb;
        border-bottom: 5px solid #fff;
      }
      .clear {
        font-size: 11px;
        color: #ff5a5a;
      }
    }
    .nav-list {
      margin: 25px auto 17px;
      display: flex;
      align-items: center;
      line-height: 26px;
      width: 335px;
      height: 30px;
      background-color: #ffffff;
      border-radius: 6px;
      box-sizing: border-box;
      border: solid 2px #f04646;
      .nav-item {
        width: 50%;
        height: 100%;
        color: #000;
        font-size: 13px;
        text-align: center;
        border-radius: 6px;
      }
      .nav-item-active {
        background-color: #f04646;
        color: #fff;
      }
      .nav-item:first-child {
        border-radius: 0px 6px 6px 0px;
      }
      .nav-item:last-child {
        border-radius: 6px 0px 0px 6px;
      }
    }
  }
  .page-content {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .page-scroll {
      height: 100%;
      overflow-y: scroll;
    }
  }
}

.select-container {
  padding: 0px 16px;
  box-sizing: border-box;
}
.select-container .button-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.select-container .button-item {
  width: 80px;
  height: 30px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 15px;
  border: solid 1px #f1f1f1;
  font-size: 13px;
  line-height: 30px;
  color: #383d48;
  margin-right: 6px;
  margin-bottom: 6px;
  text-align: center;
}
.select-container .select-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}
.select-container .button-item-active {
  border: solid 1px #383d48;
}
.select-container .button-item:last-child {
  margin-right: 0px;
}
</style>
